import React from 'react';

const CopyIcon = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {

  return (
    <svg style={{ ...style, ...overrideStyles }} width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M12.3333 0.833984H2.33332C1.41666 0.833984 0.666656 1.58398 0.666656 2.50065V14.1673H2.33332V2.50065H12.3333V0.833984ZM11.5 4.16732H5.66666C4.74999 4.16732 4.00832 4.91732 4.00832 5.83398L3.99999 17.5006C3.99999 18.4173 4.74166 19.1673 5.65832 19.1673H14.8333C15.75 19.1673 16.5 18.4173 16.5 17.5006V9.16732L11.5 4.16732ZM5.66666 17.5006V5.83398H10.6667V10.0007H14.8333V17.5006H5.66666Z" fill={color} />
    </svg>
  );
};

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

export default CopyIcon;
